import { __awaiter } from "tslib";
import { delay } from "./utils.js";
export class ScrcpyClientConnection {
    constructor(device, options) {
        this.device = device;
        this.options = options;
    }
    initialize() { }
    dispose() { }
}
export class ScrcpyClientForwardConnection extends ScrcpyClientConnection {
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.device.createSocket('localabstract:scrcpy');
        });
    }
    connectAndRetry() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < 100; i++) {
                try {
                    return yield this.connect();
                }
                catch (e) {
                    yield delay(100);
                }
            }
            throw new Error(`Can't connect to server after 100 retries`);
        });
    }
    connectVideoStream() {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = yield this.connectAndRetry();
            if (this.options.sendDummyByte) {
                const reader = stream.readable.getReader();
                const { done, value } = yield reader.read();
                // server will write a `0` to signal connection success
                if (done || value.byteLength !== 1 || value[0] !== 0) {
                    throw new Error('Unexpected response from server');
                }
                reader.releaseLock();
            }
            return stream;
        });
    }
    getStreams() {
        return __awaiter(this, void 0, void 0, function* () {
            const videoStream = yield this.connectVideoStream();
            let controlStream;
            if (this.options.control) {
                controlStream = yield this.connectAndRetry();
            }
            // Server only writes device meta after control socket is connected (if enabled)
            if (this.options.sendDeviceMeta) {
                const reader = videoStream.readable.getReader();
                const { done, value } = yield reader.read();
                // 64 bytes device name + 2 bytes video width + 2 bytes video height
                if (done || value.byteLength !== 64 + 2 + 2) {
                    throw new Error('Unexpected response from server');
                }
                reader.releaseLock();
            }
            return [videoStream, controlStream];
        });
    }
}
export class ScrcpyClientReverseConnection extends ScrcpyClientConnection {
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // try to unbind first
                yield this.device.reverse.remove('localabstract:scrcpy');
            }
            catch (_a) {
                // ignore error
            }
            const queue = new TransformStream();
            this.streams = queue.readable.getReader();
            const writer = queue.writable.getWriter();
            this.address = yield this.device.reverse.add('localabstract:scrcpy', 27183, {
                onSocket: (packet, stream) => {
                    writer.write(stream);
                },
            });
        });
    }
    accept() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.streams.read()).value;
        });
    }
    getStreams() {
        return __awaiter(this, void 0, void 0, function* () {
            const videoStream = yield this.accept();
            let controlStream;
            if (this.options.control) {
                controlStream = yield this.accept();
            }
            // Server only writes device meta after control socket is connected (if enabled)
            if (this.options.sendDeviceMeta) {
                const reader = videoStream.readable.getReader();
                const { done, value } = yield reader.read();
                // 64 bytes device name + 2 bytes video width + 2 bytes video height
                if (done || value.byteLength !== 64 + 2 + 2) {
                    throw new Error('Unexpected response from server');
                }
                reader.releaseLock();
            }
            return [videoStream, controlStream];
        });
    }
    dispose() {
        // Don't await this!
        // `reverse.remove`'s response will never arrive
        // before we read all pending data from `videoStream`
        this.device.reverse.remove(this.address);
    }
}
//# sourceMappingURL=connection.js.map